<ion-content>
  <ion-grid>

    <ion-row class="ion-justify-content-center">
      <ion-col size="12" size-md="6">
        <ion-card>
          <ion-item lines="full" color="light">
            <ion-icon slot="start" name="code-working-outline" color="primary"></ion-icon>
            <ion-label>Predefined Commands</ion-label>
          </ion-item>

          <ion-card-content>
            <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"
              (modelChange)="updatePredefined()" class="hide-empty-list-header"></formly-form>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col size="12" size-md="6">
        <ion-card>
          <ion-item lines="full" color="light">
            <ion-icon slot="start" name="code-working-outline" color="primary"></ion-icon>
            <ion-label>Manual System Execute</ion-label>
          </ion-item>

          <ion-card-content>
            <form [formGroup]="form" (ngSubmit)="submit()">
              <ion-item>
                <ion-input formControlName="username" type="text" label="Username">
                </ion-input>
              </ion-item>
              <ion-item>
                <ion-input formControlName="password" type="password" label="Password"></ion-input>
              </ion-item>
              <ion-item>
                <ion-input formControlName="timeoutSeconds" type="number" label="Timeout"></ion-input>
              </ion-item>
              <ion-item>
                <ion-toggle tabindex="0" mode="md" formControlName="runInBackground" label="Run in Background"
                  justify="space-between">Run in background</ion-toggle>
              </ion-item>
              <ion-item>
                <ion-textarea class="command-textbox" auto-grow="true" formControlName="command" type="text"
                  label="Command" label-placement="floating"></ion-textarea>
              </ion-item>
              <ion-button expand="block" type=" submit" color="primary">Send</ion-button>
            </form>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- show last output -->
    @if (stdout.length > 0 || stderr.length > 0 || loading) {
      <ion-row class="ion-justify-content-center">
        <ion-col size="12">
          <ion-card>
            <ion-item lines="full" color="light">
              <ion-icon slot="start" name="code-working-outline" color="primary"></ion-icon>
              <ion-label>Latest output</ion-label>
            </ion-item>
            <ion-card-content>
              <ngx-loading [show]="loading"></ngx-loading>
              @if (!loading) {
                @if (stdout.length > 0) {
                  <ion-item-group>
                    <ion-item-divider>
                      <ion-label>Output</ion-label>
                    </ion-item-divider>
                    <ion-item style="font-family: monospace; white-space: pre;">
                      @for (line of stdout; track line) {
                        {{ line }}<br />
                      }
                    </ion-item>
                  </ion-item-group>
                }
                @if (stderr.length > 0) {
                  <ion-item-group>
                    <ion-item-divider>
                      <ion-label>Error</ion-label>
                    </ion-item-divider>
                    <ion-item style="font-family: monospace; white-space: pre;">
                      @for (line of stderr; track line) {
                        {{ line }}<br />
                      }
                    </ion-item>
                  </ion-item-group>
                }
              }
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    }

    <!-- show command log -->
    @if (commandLogs.length > 0) {
      <ion-row class="ion-justify-content-center">
        <ion-col size="12">
          <ion-card>
            <ion-item lines="full" color="light">
              <ion-icon slot="start" name="code-working-outline" color="primary"></ion-icon>
              <ion-label>Last commands</ion-label>
            </ion-item>
            <ion-card-content>
              <ion-grid>
                <ion-row>
                  <ion-col size="1">
                    <ion-label color="primary">Timeout</ion-label>
                  </ion-col>
                  <ion-col size="1">
                    <ion-label color="primary">Run in background</ion-label>
                  </ion-col>
                  <ion-col size="9">
                    <ion-label color="primary">Command</ion-label>
                  </ion-col>
                  <ion-col size="1"></ion-col>
                </ion-row>
                @for (l of commandLogs; track l) {
                  <ion-row>
                    <ion-col size="1">{{ l.params.timeoutSeconds }}</ion-col>
                    <ion-col size="1">{{ l.params.runInBackground }}</ion-col>
                    <ion-col size="9">{{ l.params.command }}</ion-col>
                    <ion-col size="1">
                      <ion-button (click)="formGroup.controls.username.value = l.params.username;
                formGroup.controls.password.value = l.params.password;
                formGroup.controls.timeoutSeconds.value = l.params.timeoutSeconds;
                formGroup.controls.runInBackground.value = l.params.runInBackground;
                formGroup.controls.command.value = l.params.command">Repeat
                      </ion-button>
                    </ion-col>
                  </ion-row>
                }
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    }
  </ion-grid>
</ion-content>
